import { Locales } from '@ratehub/base-ui';

import withFrenchLocale from '../functions/withFrenchLocale';
import createBlogPostStaticProps from '../functions/createBlogPostStaticProps';
import BLOCK_MAP from '../definitions/TemplateBlogPostBlockMap';
import createStaticWordpressPage from '../functions/createStaticWordpressPage';


const { getStaticPaths, getStaticProps } = createBlogPostStaticProps({
    locale: Locales.FRENCH,
    fileName: 'blogPostsFR', // Must match filename use for catch all, i.e. [...ccDetailsSlugEN].jsx
    path: '/blogue', // Array to determine the url - final result is `/${rootPath.join('/')}`
    blockMap: BLOCK_MAP,
});

const page = createStaticWordpressPage({ blockMap: BLOCK_MAP });

export default withFrenchLocale(page);
export { getStaticPaths, getStaticProps };
